<template>
  <svg :class="{ 'spin-animation': spin }" width="17px" height="16px" viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <path
        id="path-1"
        d="M6.64480858,0.262295079 L6.64480858,2.18579237 L6.5347093,2.23328614 C6.39114884,2.29876982 6.19469852,2.39951361 5.94535504,2.53551915 L4.5901638,1.13661203 C5.23133275,0.728595412 5.9162075,0.437159343 6.64480858,0.262295079 Z M0,1.31147539 L1.18032792,0.13114754 L15.8251373,14.8196719 L14.6448094,15.9999998 L12.459017,13.8142075 C11.817848,14.2222241 11.1184014,14.5136601 10.3606562,14.6885244 L10.3606562,12.7650271 L10.5792356,12.6678808 C10.7346694,12.5966403 10.909532,12.5124472 11.1038256,12.4153004 L3.54098377,4.89617479 C3.13296714,5.71220801 2.92896188,6.57194439 2.92896188,7.47540973 C2.92896188,9.02004403 3.48269043,10.3315063 4.59016414,11.4098359 L6.64480904,9.35519112 L6.64480904,14.9508195 L1.04918038,14.9508195 L3.27868867,12.7213113 C1.79234238,11.2641091 1.04918038,9.51549276 1.04918038,7.47540973 C1.04918038,6.04735161 1.42804728,4.73588933 2.18579245,3.54098356 L0,1.31147539 Z M16,0 L13.7704918,2.22950815 C15.256838,3.6867103 16,5.43532666 16,7.47540967 C16,8.90346778 15.6211331,10.21493 14.863388,11.4098358 L13.4644809,10.0546446 C13.9016416,9.23861138 14.1202186,8.37887501 14.1202186,7.47540967 C14.1202186,5.93077539 13.5664901,4.61931312 12.4590164,3.54098353 L10.4043716,5.59562829 L10.4043716,0 L16,0 Z"
      ></path>
    </defs>
    <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="🌐-Icon-Left" transform="translate(0.666667, 0.000000)">
        <mask id="mask-2" fill="white">
          <use xlink:href="#path-1"></use>
        </mask>
        <g id="ic_action_sync_off" fill-rule="nonzero"></g>
        <g id="Color" mask="url(#mask-2)" fill="currentColor">
          <rect id="🎨-Color" x="0" y="0" width="16" height="16"></rect>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'RebaseIcon',
    props: {
      spin: {
        type: Boolean,
        default: () => false
      }
    }
  };
</script>
<style lang="scss" scoped>
  svg {
    vertical-align: middle;
  }
  svg:hover {
    fill: currentColor;
  }
</style>
